<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="auto !important"
    class="bg-white pos-relative"
  >
    <v-card>
      <v-card-title class="fs-1-5r bg-grey mb-4">
        <span> SFTP Access Details </span>
      </v-card-title>
      <div
        v-if="
          isTarget &&
          route.foldersHierarchy.isSenderEmail &&
          route.sourceEndPoints.length
        "
      >
        <div class="select-senders">
          <span class="px-2 text-h6 text-black mr-4">Path to:</span>
          <v-autocomplete
            class="autocomplete-sesnders"
            v-model="sender"
            :items="route.sourceEndPoints"
            placeholder="All Senders"
            hide-no-data
            :menu-props="{ closeOnContentClick: false }"
            @click:append="toggleMenu"
            ref="autocomplete"
            return-object
            hide-details
            item-text="userEmail"
          >
            <template v-slot:selection="{ item }">
              <span class="pill text-black">
                {{ item.userName }}
              </span>
            </template>

            <template v-slot:item="{ item, attrs }">
              <v-list-item-avatar>
                <v-simple-checkbox
                  :value="attrs.inputValue"
                  hide-details
                  class="ma-0 pa-0"
                  color="primary"
                >
                </v-simple-checkbox>
              </v-list-item-avatar>
              <v-list-item-content class="dir-ltr">
                <div class="div-click-fixer"></div>
                <div class="div-click-fixer-left"></div>
                <v-list-item-title v-html="item.userEmail"></v-list-item-title>
                <v-list-item-subtitle
                  class="text-black"
                  v-html="item.userName"
                ></v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </div>
        <v-divider class="mb-4" />
      </div>
      <v-card-text class="font-size-16 px-2 pb-2 text-black">
        Protocol: SFTP
      </v-card-text>
      <v-card-text class="font-size-16 px-2 pb-2 text-black">
        Port: 22
      </v-card-text>
      <v-card-text class="font-size-16 px-2 pb-2 text-black">
        Host: {{ computedHost }}
      </v-card-text>
      <v-card-text class="font-size-16 px-2 pb-2 text-black">
        Username: {{ computedUsername }}
      </v-card-text>
      <v-card-text class="font-size-16 px-2 pb-2 text-black">
        Password: {{ userName }} Yazam MFT password
      </v-card-text>
      <v-divider></v-divider>
      <div class="d-flex justify-space-between pa-4">
        <Button
          :clickAction="sendEmailClicked"
          width="fit-content"
          btnType="blue"
          class="mr-4"
          text="Send Details by Email"
        />
        <Button
          :clickAction="closeDialog"
          width="fit-content"
          btnType="grey"
          text="Cancel"
        />
      </div>
    </v-card>
    <InsertEmailDialog
      v-if="isShowInsertDialog"
      :closeDialog="() => (isShowInsertDialog = false)"
      :routeName="route.name"
      :sftpUsername="computedUsername"
      :isTarget="isTarget"
    />
  </v-dialog>
</template>

<script>
import Button from '@/components/BaseComponents/Button/Button.vue'
import InsertEmailDialog from './Children/InsertEmailDialog.vue'

export default {
  name: 'SftpDetailsDialog',
  data() {
    return {
      dialog: true,
      sender: null,
      isShowInsertDialog: false,
    }
  },
  props: {
    isTarget: Boolean,
    userEmail: String,
    userName: String,
    route: Object,
    closeDialog: Function,
  },
  components: { Button, InsertEmailDialog },

  computed: {
    computedHost() {
      return window.location.host
    },
    computedUsername() {
      const username = this.isTarget
        ? `${this.userEmail}${this.sender ? '\\' + this.sender.userEmail : ''}`
        : this.userEmail + ',' + this.route.name
      console.log(username)
      return username
    },
  },
  methods: {
    sendEmailClicked() {
      this.isShowInsertDialog = true
    },
    toggleMenu() {
      this.$refs.autocomplete.isMenuActive =
        !this.$refs.autocomplete.isMenuActive
    },
  },
  created() {
    console.log(this.route)
  },
}
</script>

<style scoped>
.select-senders {
  padding: 0px 8px 7px 0px;
  display: flex;
  justify-content: space-between;
  align-items: end;
}

.autocomplete-sesnders {
  max-width: 50%;
}

.autocomplete-sesnders >>> input {
  width: 0;
}

.text-black {
  color: black !important;
}
</style>
